import { render, staticRenderFns } from "./AvoidPage.vue?vue&type=template&id=98a68b12&scoped=true&"
import script from "./AvoidPage.vue?vue&type=script&lang=js&"
export * from "./AvoidPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a68b12",
  null
  
)

export default component.exports